import React from 'react';

const Preloader = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="text-center text-white animate-ping">
        <h1 className="text-4xl font-bold font-serif mb-4 md:mb-6">
          <span className="inline-block md:mx-4">Vision,</span>
          <span className="inline-block md:mx-4">Valour,</span>
          <span className="inline-block">Vigilance</span>
        </h1>
      </div>
    </div>
  );
};

export default Preloader;
